import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "record-header" }
const _hoisted_2 = { class: "m-right-sm" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "m-left-right-sm" }, "-", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "el-icon-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_custom_table = _resolveComponent("custom-table")
  const _component_custom_form_template = _resolveComponent("custom-form-template")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    width: "1500px",
    title: _ctx.$wordList.PaymentRecords,
    onClose: _ctx.close,
    footerType: "customize"
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$wordList.TabelMessageBoxCreateTime), 1),
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.formData.BeginTime,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.BeginTime = $event)),
          type: "datetime",
          format: "YYYY-MM-DD HH:mm:ss"
        }, null, 8, ["modelValue"]),
        _hoisted_3,
        _createVNode(_component_el_date_picker, {
          class: "m-right-md",
          type: "datetime",
          format: "YYYY-MM-DD HH:mm:ss",
          modelValue: _ctx.formData.EndTime,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.EndTime = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_cus_button, {
          onClick: _ctx.searchList,
          class: "m-left-md"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(_ctx.$wordList.LogInHtmlSearch), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_custom_form_template, {
        "page-size": _ctx.formData.row,
        "onUpdate:page-size": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.row = $event)),
        "cur-page": _ctx.formData.page,
        "onUpdate:cur-page": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.page = $event)),
        total: +_ctx.tableData.total,
        onSizeChange: _ctx.getRoomPaymentListApi,
        onPageChange: _ctx.getRoomPaymentListApi
      }, {
        table: _withCtx(() => [
          _createVNode(_component_custom_table, {
            column: _ctx.column,
            tableData: _ctx.tableData.row
          }, {
            ProductName: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.formatDate(scope.item.EffectDate, scope.item.ExpireDate, scope.item.IsAutoSend === 1)), 1)
            ]),
            Status: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.mapWordOfStatus[scope.item.Status]), 1)
            ]),
            _: 1
          }, 8, ["column", "tableData"])
        ]),
        _: 1
      }, 8, ["page-size", "cur-page", "total", "onSizeChange", "onPageChange"])
    ]),
    _: 1
  }, 8, ["title", "onClose"]))
}